module.exports = __webpack_public_path__ + "img/18.46c33d92.jpg";